angular.module("app").constant("userStatuses", [
    "published",
    "inactive",
    "archive"
]);